import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import People from "@material-ui/icons/People";
import { grey } from "@material-ui/core/colors";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import {
  shiftTypeToString,
  bookingSystemTypeToString,
} from "features/planner/planner.mappers";

import SortableListRow from "app/components/SortableList/SortableListRow";
import { getPOBReportGroupFromState } from "features/planner/report/report.selectors";

class POBReportGroup extends PureComponent {
  render() {
    const { pobReportGroup, classes } = this.props;

    const employees = pobReportGroup.get("employees");
    const bookingSystemType = pobReportGroup.get("bookingSystemType");

    return (
      <Grid container item className={classes.root}>
        <Grid container className={classes.subRoot}>
          <Grid container className={classes.heading}>
            <Grid
              item
              container
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="subtitle2">
                  {pobReportGroup.get("groupName")}
                </Typography>
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <People />
                  &nbsp;
                  <Typography variant="subtitle2">
                    x {employees.size}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <SortableListRow noborder striped={false}>
            <Grid item xs={2}>
              <Typography className={classes.columnDescription}>
                {bookingSystemTypeToString(bookingSystemType)}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography className={classes.columnDescription}>
                Name
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography className={classes.columnDescription}>
                Shift
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.columnDescription}>
                Days
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.columnDescription}>
                Qualification
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.columnDescription}>
                Heli
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.columnDescription}>Ref</Typography>
            </Grid>
          </SortableListRow>
          <Grid item container>
            {employees.map(employee => (
              <SortableListRow
                noborder
                striped={false}
                key={employee.get("id")}
                classes={{
                  root: classes.listRow,
                }}
              >
                <Grid item xs={2} className={classes.column}>
                  <Typography>
                    {employee.getIn(["travel", bookingSystemType])}
                  </Typography>
                </Grid>
                <Grid item xs={3} className={classes.column}>
                  <Typography noWrap>{employee.get("displayName")}</Typography>
                </Grid>
                <Grid item xs={1} className={classes.column}>
                  <Typography>
                    {shiftTypeToString(employee.get("shiftType"))[0]}
                  </Typography>
                </Grid>
                <Grid item xs className={classes.column}>
                  <Typography>{employee.get("deploymentDayCount")}</Typography>
                </Grid>
                <Grid item xs className={classes.column}>
                  <Typography>{employee.get("qualificationName")}</Typography>
                </Grid>
                <Grid item xs className={classes.column} />
                <Grid item xs className={classes.column} />
              </SortableListRow>
            ))}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  heading: {
    background: grey[300],
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    height: theme.altus.mediumRow.height,
  },
  listRow: {
    borderTop: `1px solid ${grey[300]}`,
    borderBottom: "1px solid transparent",
  },
  columnDescription: {
    fontWeight: 700,
    padding: theme.spacing(1),
  },
  column: {
    padding: theme.spacing(1),
  },
  subRoot: {
    borderTop: "none",
    border: `1px solid ${grey[300]}`,
  },
  root: {
    pageBreakBefore: "always",
  },
});

export default compose(
  connect((state, { groupId }) => ({
    pobReportGroup: getPOBReportGroupFromState(state, groupId),
  })),
  withStyles(styles),
)(POBReportGroup);
